import * as React from 'react'

import { Text } from '../text/Text'

export type SliderStepsType = {
  steps?: { label: string; value: number }[]
}

type SliderStepsProps = {
  min: number
  max: number
} & SliderStepsType

const getPercentValue = (value: number, min: number, max: number): number => {
  return ((value - min) / (max - min)) * 100
}

const getTransformValue = (value: number, min: number, max: number): number => {
  const percentage = getPercentValue(value, min, max)

  if (percentage <= 10) return 0
  if (percentage >= 90) return 100
  return 50
}

export const SliderSteps = ({ min, max, steps = [] }: SliderStepsProps) => {
  if (steps.length === 0) return null

  return (
    <div className="relative mt-3 h-3 w-full">
      {steps.map((step) => (
        <Text
          as="span"
          key={step.value}
          style={{
            '--left': `${getPercentValue(step.value, min, max)}%`,
            '--translate-x': `-${getTransformValue(step.value, min, max)}%`
          }}
          className="text-grey-700 absolute left-(--left) translate-x-(--translate-x)"
        >
          {step.label}
        </Text>
      ))}
    </div>
  )
}
